.group.text :global .MuiToggleButtonGroup-grouped {
  margin: 0 2px;
  border: 0;

  &.Mui-selected + .MuiToggleButtonGroup-grouped.Mui-selected {
    margin-left: 2px;
  }

  &.Mui-disabled {
    border: 0;
  }

  &:not(:first-of-type) {
    border-radius: 4px;
  }
  &:first-of-type {
    border-radius: 4px;
  }
}
